export const ROUTES = {
  clinicalCodeRules: {
    parentPath: "admin",
    slug: "clinical-code-rules",
    route: "/admin/clinical-code-rules",
  },
};
